import React from 'react'
import { IconButton, makeStyles, TablePagination } from '@material-ui/core'
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2),
  },
}))

const TablePaginationWrapper = ({ ...overrides }) => {
  const classes = useStyles()
  const tablePaginationConfig = {
    ...overrides,
  }

  const count = tablePaginationConfig.totalItems
  /* 
    MUI TablePagination page prop is zero indexed, 
    so we need to set a currentPageCounter to track 
    the page # we send to the API
  */
  const currentPage = tablePaginationConfig.currentPage - 1
  const currentPageCounter = tablePaginationConfig.currentPage
  const onPageChange = tablePaginationConfig.onChange
  const pageSize = tablePaginationConfig.pageSize

  const TablePaginationActions = () => {
    const handleFirstPageButtonClick = () => onPageChange(1)

    const handleBackButtonClick = () => onPageChange(currentPageCounter - 1)

    const handleNextButtonClick = () => onPageChange(currentPageCounter + 1)

    const handleLastPageButtonClick = () =>
      onPageChange(Math.max(0, Math.ceil(count / pageSize)))

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={currentPage === 0}
          aria-label="first page"
        >
          <FirstPage />
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={currentPage === 0}
          aria-label="previous page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={currentPage >= Math.ceil(count / pageSize) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={currentPage >= Math.ceil(count / pageSize) - 1}
          aria-label="last page"
        >
          <LastPage />
        </IconButton>
      </div>
    )
  }

  return (
    <TablePagination
      component="div"
      count={count}
      onPageChange={(event, page) => onPageChange(page)}
      page={currentPage}
      rowsPerPage={pageSize}
      rowsPerPageOptions={[pageSize]}
      ActionsComponent={TablePaginationActions}
      {...tablePaginationConfig}
    />
  )
}

export default TablePaginationWrapper
